import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { Subtext } from './Typography';
import { ssColorCyan, ssColorWhite } from '../constants/style-constants';

const barChartCSS = score => css`
  display: inline-block;
  width: 100%;
  height: 1rem;
  background: ${ssColorWhite};

  div {
    width: ${score * 10}%;
    height: 1rem;
    background: ${ssColorCyan};
  }
`;

const TableBarChart = ({ score }) => (
  <div>
    <div css={barChartCSS(score)}>
      <div />
    </div>
    <Subtext>{`${score} / 10`}</Subtext>
  </div>
);

TableBarChart.propTypes = {
  score: PropTypes.number.isRequired,
};

export default TableBarChart;
